import { render, staticRenderFns } from "./ReturnSend.vue?vue&type=template&id=b60852b4&scoped=true"
import script from "./ReturnSend.vue?vue&type=script&lang=js"
export * from "./ReturnSend.vue?vue&type=script&lang=js"
import style0 from "./ReturnSend.vue?vue&type=style&index=0&id=b60852b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60852b4",
  null
  
)

export default component.exports